import { RECEIPT_API_URL } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export function GetReceiptApprovationList(){
    const api = `${RECEIPT_API_URL}approving/all/`;
    return axiosHttp.get(api)
}